import { createContext } from 'preact'
import { FormSetting, PARENT_WINDOW_SIZE, Platform } from 'scripts/type'
import { WidgetWidth } from 'components/business/Preview/type'

type BaseContextProps = {
  parentWindowSize: PARENT_WINDOW_SIZE
  interactive: boolean
  isPreview: boolean
  isUrlVisit?: boolean
  urlToken: string
  forcePlatformAs?: Platform
  editingFieldIndex?: number
  editingCode?: string
  formSetting?: FormSetting
  onFieldClick?: (code: string) => void
  width: WidgetWidth
}

const BaseContext = createContext<BaseContextProps>({
  parentWindowSize: PARENT_WINDOW_SIZE.MD,
  interactive: true,
  isPreview: false,
  urlToken: '',
  forcePlatformAs: undefined,
  editingCode: undefined,
  width: WidgetWidth.NORMAL,
})

export default BaseContext
